import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

export const WarningIcon = ({ ...rest }: SvgIconProps) => {
  return (
    <SvgIcon {...rest}>
      <path d="M3.58485 21H20.4152C21.2904 21 22 20.2904 22 19.4152C22 19.143 21.9299 18.8754 21.7965 18.6382L13.4903 3.87158C13.1874 3.33318 12.6177 3 12 3C11.3823 3 10.8126 3.33318 10.5097 3.87158L2.20353 18.6382C2.0701 18.8754 2 19.143 2 19.4152C2 20.2904 2.70956 21 3.58485 21Z" />
      <path d="M12 17.5V13" />
      <path d="M12 9.51V9.5" />
    </SvgIcon>
  )
}
